const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
  attachAuthIsReady: true,
  updateProfileOnLogin: false,
  logErrors: false,
};

export default rrfConfig;